import {
  Component,
  ChangeDetectorRef,
  ViewChild,
  AfterViewInit,
  OnInit,
  ElementRef,
  OnDestroy,
  Renderer2,
  HostListener
} from '@angular/core';
import { LlModelsService } from '../ll-models.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlInfoRequestsService } from '../ll-info-requests.service';

interface StudyColumn {
  STUDYCOLUMNQUESTIONIDALPHA: string;
  studyColumnLabel: string;
  studyColumnDescription: string;
  studyColumnWidth: number;
}

@Component({
  selector: 'll-model-cash-upload',
  templateUrl: './ll-model-cash-upload.component.html',
  styleUrls: ['./ll-model-cash-upload.component.css']
})
export class LlModelCashUploadComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainDiv_ll_model_cash_upload') mainDiv!: ElementRef<HTMLDivElement>;
  @ViewChild('scrollBox') scrollBox!: ElementRef<HTMLDivElement>;

  bundle = {
    showThis: true,
    canUpload: true,
    documents: <any[]>[],

    columns: <StudyColumn[]>[],

    sampleData: <any[]>[],
    sampleDataReady: false,

    uploadDataReady: false,
    fileSaved: false,
    canDelete: false,

    uploadedFile: <any[]>[],
    mappingHeaders: <string[]>[],

    docIndex: 0,

    parentW: 0,
    parentH: 0,

    sampleGridY: 0,
    sampleGridH: 200,

    gridY: 0,
    gridX: 10,
    gridW: 0,
    gridH: 0,

    fileBoxY: 0,
    fileBoxX: 0,
    fileBoxW: 300,
    fileBoxH: 0,

    acceptedExts: '',
    columnNameList:''
  };

  tooltipState: { [key: string]: { visible: boolean; x: number; y: number } } = {};
  hoveredColumn: string | null = null;
  hoveredMappingHeader: string | null = null;

  // DRAG STATE
  dragging = false;
  ghostEl: HTMLElement | null = null;
  selectedFileColumn: string = '';
  lastX = 0;
  lastY = 0;
  private sampleTableBody: HTMLTableSectionElement | null = null;

  constructor(
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    public LlModelsService: LlModelsService,
    public LlInfoRequestsService: LlInfoRequestsService,
    public LlPermissionsService: LlPermissionsService
  ) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.setVars();
    this.loadData();

    const style = this.renderer.createElement('style');
    this.renderer.appendChild(this.mainDiv.nativeElement, style);
    this.renderer.setProperty(style, 'innerHTML', `
      tr:hover td, tr:hover th,
      .sampleGrid tr:hover td, .mappingGrid tr:hover td {
        background: transparent !important;
      }
    `);

    setTimeout(() => {
      this.sampleTableBody = document.querySelector('.sampleGrid tbody') as HTMLTableSectionElement;
    }, 500);
  }

  ngOnDestroy(): void {
    if (this.ghostEl) this.ghostEl.remove();
  }

  private setVars(): void {
    this.bundle.canUpload = this.LlPermissionsService.check('upload');
    this.bundle.canDelete = this.LlPermissionsService.check('canDeleteUpLoad');
    const parentEl = this.mainDiv.nativeElement.parentElement?.parentElement;
    if (!parentEl) return;
    this.bundle.parentW = parentEl.clientWidth;
    this.bundle.parentH = parentEl.clientHeight;
    this.bundle.fileBoxH = this.bundle.parentH - this.bundle.fileBoxY - 100;
    this.bundle.sampleGridY = this.bundle.fileBoxY + 40;
    this.bundle.gridX = this.bundle.fileBoxX + this.bundle.fileBoxW + 20;
    this.bundle.gridY = this.bundle.sampleGridY + this.bundle.sampleGridH + 20;
    this.bundle.gridW = Math.max(this.bundle.parentW - this.bundle.gridX - 20, 400);
    this.bundle.gridH = this.bundle.parentH - this.bundle.gridY - 60;
    this.cdr.detectChanges();
  }

  private loadData(): void {
    this.bundle.sampleDataReady = false;
    this.bundle.uploadDataReady = false;

    this.LlInfoRequestsService.NG_LL_infoReq_uploads_map_acceptedExtentions_get((exts: string) => {
      this.bundle.acceptedExts = exts;

      this.LlInfoRequestsService.NG_LL_model_AR_cash_upload_docs_get((docs: any[]) => {
        this.bundle.documents = docs || [];
        const activeId = this.LlInfoRequestsService.getActiveStudyUploadId();
        this.bundle.docIndex = docs.findIndex(d => d.STUDYUPLOADID === activeId);
        if (this.bundle.docIndex === -1) this.bundle.docIndex = 0;

        const selectedDoc = this.bundle.documents[0];

        //console.log("selectedDoc.SAVED:" + selectedDoc.SAVED)
        //console.log("selectedDoc.RECONCILED:" + selectedDoc.RECONCILED)

        if (selectedDoc.SAVED === 'Yes') {
          this.bundle.fileSaved = true;
        } else {
          this.bundle.fileSaved = false;
        }

        if (this.bundle.canDelete === true && selectedDoc.RECONCILED === 'No') {
          this.bundle.canDelete = true;

        } else {
          this.bundle.canDelete = false;
        }

        this.LlInfoRequestsService.NG_LL_model_AR_cash_upload_columns_get((cols: any[]) => {
          this.bundle.columns = (cols || []).map((col: any) => ({
            STUDYCOLUMNQUESTIONIDALPHA: (col.STUDYCOLUMNQUESTIONIDALPHA || '').toString().toUpperCase().trim(),
            studyColumnLabel: col.STUDYCOLUMNLABEL || 'UNKNOWN',
            studyColumnDescription: col.STUDYCOLUMNDESCRIPTION || '',
            studyColumnWidth: parseInt(col.STUDYCOLUMNWIDTH, 10) || 120
          })).filter(col => col.STUDYCOLUMNQUESTIONIDALPHA);

          this.LlInfoRequestsService.NG_LL_model_AR_cash_upload_sampleData_get((samp: any[]) => {
            this.bundle.sampleData = (samp || []).map((row: any) => {
              const normalized: any = {};
              Object.keys(row || {}).forEach(key => {
                const upperKey = (key || '').toString().toUpperCase().trim();
                if (upperKey) normalized[upperKey] = row[key];
              });
              return normalized;
            });

            setTimeout(() => {
              this.bundle.sampleDataReady = true;
              this.cdr.detectChanges();
              this.getUploadFile();
            }, 200);
          });
        });
      });
    });
  }

  getUploadFile(): void {
    this.bundle.uploadDataReady = false;
    this.LlInfoRequestsService.NG_LL_model_AR_cash_uploads_map((fileMap: any[]) => {
      this.bundle.uploadedFile = fileMap || [];
      this.refreshMappingHeaders();

      this.bundle.columnNameList = this.bundle.uploadedFile[0].LOANMODELUPLOADMAPID;

      ///console.log("LOANMODELUPLOADMAPID: "+)

      setTimeout(() => {
        this.bundle.uploadDataReady = true;
        this.cdr.detectChanges();
      }, 100);
    });
  }

  // ────────────────────────────────────────────────
  // NEW: Column width helper for mapping grid
  // First 10 columns try to match sample grid widths
  // ────────────────────────────────────────────────
  getMappingColumnWidth(index: number): number {
    if (index < this.bundle.columns.length) {
      return this.bundle.columns[index].studyColumnWidth;
    }
    // fallback for columns 11+
    return 140;   // ← adjust this value to what looks good for unmapped columns
  }

  getHeaderValue(header: string, row: any): string {
    if (!row) return '';
    const col = this.bundle.columns.find(c => c.studyColumnLabel.toLowerCase() === header.toLowerCase());
    if (col) {
      const keyMatch = Object.keys(row).find(key =>
        key.toLowerCase().trim() === col.STUDYCOLUMNQUESTIONIDALPHA.toLowerCase().trim()
      );
      if (keyMatch !== undefined) return row[keyMatch] ?? '';
    }
    return row[header] ?? '';
  }

  // ================== DRAG TO RENAME COLUMN ==================
  startDrag(event: MouseEvent | TouchEvent, header: string) {
    if (this.dragging) return;
    const cell = (event.currentTarget as HTMLElement);
    if (!cell) return;

    this.dragging = true;
    this.selectedFileColumn = header;

    const clientX = 'touches' in event ? event.touches[0].clientX : (event as MouseEvent).clientX;
    const clientY = 'touches' in event ? event.touches[0].clientY : (event as MouseEvent).clientY;

    this.ghostEl = this.renderer.createElement('div');
    this.renderer.addClass(this.ghostEl, 'drag-ghost');
    this.renderer.setProperty(this.ghostEl, 'innerText', header);
    this.renderer.appendChild(document.body, this.ghostEl);
    this.updateGhostPosition(clientX, clientY);

    const colIndex = Array.from(cell.parentElement!.children).indexOf(cell);
    if (this.sampleTableBody) {
      this.highlightColumn(this.sampleTableBody, colIndex, false);
    }

    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:touchmove', ['$event'])

  onDragMove(event: MouseEvent | TouchEvent) {
    if (!this.dragging || !this.ghostEl) return;
    const clientX = 'touches' in event ? event.touches[0].clientX : event.clientX;
    const clientY = 'touches' in event ? event.touches[0].clientY : event.clientY;
    this.updateGhostPosition(clientX, clientY);

    const targetCell = this.getCellUnderPoint(clientX, clientY);
    document.querySelectorAll('.drop-column').forEach(el => el.classList.remove('drop-column'));
    if (targetCell && targetCell.closest('.sampleGrid')) {
      const colIndex = Array.from(targetCell.parentElement!.children).indexOf(targetCell);
      this.highlightColumn(this.sampleTableBody!, colIndex, false);
    }
  }

  @HostListener('document:mouseup')
  @HostListener('document:touchend')

  onDragEnd() {
    if (!this.dragging) return;
    this.dragging = false;

    document.querySelectorAll('.drag-source, .drop-column').forEach(el => {
      el.classList.remove('drag-source', 'drop-column');
    });
    if (this.ghostEl) {
      this.ghostEl.remove();
      this.ghostEl = null;
    }

    const targetCell = this.getCellUnderPoint(this.lastX, this.lastY);
    if (targetCell && targetCell.closest('.sampleGrid')) {
      const row = targetCell.parentElement!;
      const colIndex = Array.from(row.children).indexOf(targetCell);
      const headerCell = targetCell.closest('table')!.querySelector(`thead th:nth-child(${colIndex + 1})`);
      const targetLabel = headerCell?.textContent?.trim();
      const targetCol = this.bundle.columns.find(c => c.studyColumnLabel === targetLabel);

      if (targetCol && this.selectedFileColumn) {
        const oldHeader = this.selectedFileColumn;
        const newHeader = targetCol.STUDYCOLUMNQUESTIONIDALPHA;

        // 1. Rename key in ALL rows
        this.bundle.uploadedFile.forEach((row: any) => {
          if (oldHeader in row) {
            row[newHeader] = row[oldHeader];
            delete row[oldHeader];
          }
        });

        // 2. Update COLUMNALLNAMES in first row
        const firstRow = this.bundle.uploadedFile[0];
        if (firstRow?.COLUMNALLNAMES) {
          const names = firstRow.COLUMNALLNAMES.split('|').map(s => s.trim());
          const idx = names.indexOf(oldHeader);
          if (idx > -1) {
            names[idx] = newHeader;
            firstRow.COLUMNALLNAMES = names.join('|');
          }
        }

        this.LlInfoRequestsService.NG_LL_model_AR_cash_uploads_map_values_edit(
          this.bundle.uploadedFile[0].LOANMODELUPLOADMAPID,
          targetCol.STUDYCOLUMNQUESTIONIDALPHA,
          this.selectedFileColumn,
          this.bundle.uploadedFile[0].COLUMNALLNAMES

        );

        // 3. Refresh UI
        this.refreshMappingHeaders();
        this.flashSuccess();
      }
    }
  }

  updateGhostPosition(x: number, y: number) {
    if (!this.ghostEl) return;
    this.lastX = x;
    this.lastY = y;
    this.renderer.setStyle(this.ghostEl, 'left', `${x + 12}px`);
    this.renderer.setStyle(this.ghostEl, 'top', `${y + 12}px`);
  }

  getCellUnderPoint(x: number, y: number): HTMLElement | null {
    const el = document.elementFromPoint(x, y);
    return el?.closest('td, th') as HTMLElement;
  }

  highlightColumn(tbody: HTMLTableSectionElement | null, index: number, isDrop: boolean) {
    if (!tbody) return;
    const className = isDrop ? 'drop-column' : 'drag-source';
    tbody.querySelectorAll(`tr > :nth-child(${index + 1})`).forEach(cell => {
      this.renderer.addClass(cell, className);
    });
  }

  refreshMappingHeaders() {
    const firstRow = this.bundle.uploadedFile[0] || {};
    const allFileColumns = firstRow.COLUMNALLNAMES
      ? firstRow.COLUMNALLNAMES.split('|').map((h: string) => h.trim()).filter(Boolean)
      : Object.keys(firstRow).filter(k => k && typeof firstRow[k] !== 'undefined');

    const fileColumnLower = allFileColumns.map(c => c.toLowerCase().trim());
    const matchedStudyLabels = new Set<string>();
    const studyLabels = this.bundle.columns.map(col => {
      const alphaLower = col.STUDYCOLUMNQUESTIONIDALPHA.toLowerCase().trim();
      if (fileColumnLower.includes(alphaLower)) {
        matchedStudyLabels.add(col.studyColumnLabel);
      }
      return col.studyColumnLabel;
    });

    const matchedFileColumnNames = new Set<string>();
    this.bundle.columns.forEach(col => {
      const match = allFileColumns.find(fc =>
        fc.toLowerCase().trim() === col.STUDYCOLUMNQUESTIONIDALPHA.toLowerCase().trim()
      );
      if (match) matchedFileColumnNames.add(match);
    });

    const unmappedFileColumns = allFileColumns.filter(col => !matchedFileColumnNames.has(col));

    this.bundle.mappingHeaders = [
      ...studyLabels,
      ...unmappedFileColumns
    ].slice();

    //console.log(matchedFileColumnNames)

    this.cdr.detectChanges();
  }

  flashSuccess() {
    const el = this.renderer.createElement('div');
    this.renderer.addClass(el, 'drag-success');
    this.renderer.setProperty(el, 'innerText', 'Column Renamed!');
    this.renderer.appendChild(document.body, el);
    setTimeout(() => el.remove(), 2000);
  }

  // ================== UI HELPERS ==================
  showColumnTooltip(event: MouseEvent, colId: string) {
    const x = event.clientX - 240;
    const y = event.clientY - 10;
    this.tooltipState[colId] = { visible: true, x, y };
    this.cdr.detectChanges();
  }

  hideColumnTooltip(colId: string) {
    if (this.tooltipState[colId]) {
      this.tooltipState[colId].visible = false;
      this.cdr.detectChanges();
    }
  }

  setColumnHover(colId: string | null, isSample: boolean = true) {
    if (isSample) this.hoveredColumn = colId;
    else this.hoveredMappingHeader = colId;
  }

  goBack(): void { this.bundle.showThis = false; }

  fileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const fileList: FileList | null = input.files;
    if (!fileList || fileList.length === 0) return;
    const file: File = fileList[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Data = String(reader.result).split(',')[1];
      this.LlInfoRequestsService.NG_LL_infoReq_uploads_add(
        (success: boolean) => { if (success) this.loadData(); },
        this.bundle, file, base64Data
      );
    };
    input.value = '';
  }

  saveFile(): void {

    //console.log("saveFile LOANMODELUPLOADMAPID:" + this.bundle.uploadedFile[0].LOANMODELUPLOADMAPID)
    // TODO: implement actual save logic

    this.bundle.documents[this.bundle.docIndex].SAVED = "Yes";
    this.bundle.fileSaved = true;
    if (this.bundle.canDelete === true ) {
      this.bundle.canDelete = true;
    }

    this.LlInfoRequestsService.NG_LL_model_AR_cash_upload_docs_save(this.bundle.uploadedFile[0].LOANMODELUPLOADMAPID) 


  }

  deleteFile(): void {

    this.LlInfoRequestsService.NG_LL_model_AR_cash_upload_docs_delete(this.loadData(), this.bundle.uploadedFile[0].LOANMODELUPLOADMAPID)

    
  }

  selectDocument(index: number): void {
    this.bundle.docIndex = index;
    const selectedDoc = this.bundle.documents[this.bundle.docIndex];

   ///console.log("selectedDoc.SAVED:" + selectedDoc.SAVED)
    ///console.log("selectedDoc.RECONCILED:" + selectedDoc.RECONCILED)

    if (selectedDoc.SAVED === 'Yes') {
      this.bundle.fileSaved = true;
    } else {
      this.bundle.fileSaved = false;
    }

    if (this.bundle.canDelete === true && selectedDoc.RECONCILED === 'No') {
      this.bundle.canDelete = true;

    } else {
      this.bundle.canDelete = false;
    }


    this.LlInfoRequestsService.setActiveStudyUploadId(selectedDoc.STUDYUPLOADID);
    this.getUploadFile();
  }

  isStudyColumn(header: string): boolean {
    return this.bundle.columns.some(col =>
      col.studyColumnLabel.toLowerCase().trim() === header.toLowerCase().trim()
    );
  }
}
